// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerV1.module.css */

/* Корневой контейнер сканера */
.ScannerV1_container__I96Is {
  position: relative;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 360px;
  margin: auto;
}

/* Видеопревью */
.ScannerV1_video__WOPlQ {
  width: 100%;
  height: auto;
  object-fit: cover;
}

/* Скрытый canvas для снимков */
.ScannerV1_hidden__WMned {
  display: none;
}

/* Контейнер для кнопок управления */
.ScannerV1_controls__b1cuX {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 16px;
  z-index: 10;
}

/* Общий стиль кнопок */
.ScannerV1_btn__ywr8j {
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  padding: 8px;
  font-size: 20px;
  cursor: pointer;
  transition: background 0.2s;
}

/* Ховер-эффект для кнопок */
.ScannerV1_btn__ywr8j:hover {
  background: rgba(255, 255, 255, 1);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/pages/Scanners/styles/ScannerV1.module.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;AACpC","sourcesContent":["/* src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerV1.module.css */\r\n\r\n/* Корневой контейнер сканера */\r\n.container {\r\n  position: relative;\r\n  background: #000;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  max-width: 360px;\r\n  margin: auto;\r\n}\r\n\r\n/* Видеопревью */\r\n.video {\r\n  width: 100%;\r\n  height: auto;\r\n  object-fit: cover;\r\n}\r\n\r\n/* Скрытый canvas для снимков */\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n/* Контейнер для кнопок управления */\r\n.controls {\r\n  position: absolute;\r\n  bottom: 12px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  gap: 16px;\r\n  z-index: 10;\r\n}\r\n\r\n/* Общий стиль кнопок */\r\n.btn {\r\n  background: rgba(255, 255, 255, 0.8);\r\n  border: none;\r\n  border-radius: 50%;\r\n  padding: 8px;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n/* Ховер-эффект для кнопок */\r\n.btn:hover {\r\n  background: rgba(255, 255, 255, 1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScannerV1_container__I96Is`,
	"video": `ScannerV1_video__WOPlQ`,
	"hidden": `ScannerV1_hidden__WMned`,
	"controls": `ScannerV1_controls__b1cuX`,
	"btn": `ScannerV1_btn__ywr8j`
};
export default ___CSS_LOADER_EXPORT___;
